import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { ComingSoonImage, ModalCloseIcon } from '../Icons';
import { Divider } from '@mui/material';
import styled from 'styled-components';

const StyledTitle = styled.div`
	font-size: 18px;
	font-weight: bold;
	color: black;
`;

const StyledText = styled.div`
	font-size: 16px;
	font-weight: 600;
	color: var(--color-font-grey);
	text-align: center;
`;

interface Props {
	open: boolean;
	setOpen: (value: boolean) => void;
	style?: React.CSSProperties | {};
}

const modalStyling = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	outline: 'none !important',
	maxWidth: '381px',
	maxHeight: '301px',
	backgroundColor: 'background.paper',
	borderRadius: '4px',
	boxShadow: '24px',
	letterSpacing: '0.28px',
};

export default function ComingSoonModal({ open, setOpen, style }: Props) {
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	const mobileStyle = {
		...modalStyling,
		...style,
	};

	return (
		<Modal
			open={open}
			onClose={() => {
				handleClose();
			}}
			aria-labelledby="modal-modal-title"
			aria-describedby="modal-modal-description"
		>
			<Box
				sx={{
					...mobileStyle,
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					justifyContent: 'center',
					gap: '16px',
					padding: '24px',
				}}
			>
				<ComingSoonImage />
				<StyledTitle>Coming Soon!</StyledTitle>
				<StyledText>
					Unlock the excitement! New feature are on the horizon. Stay tuned for updates.
				</StyledText>
			</Box>
		</Modal>
	);
}
